export const ENV = {
  // Orby
  ORBY_GRAPHQL_BASE_URL: import.meta.env.VITE_ORBY_GRAPHQL_BASE_URL ?? "",
  ORBY_INSTANCE_PRIVATE_API_KEY: import.meta.env.VITE_ORBY_INSTANCE_PRIVATE_API_KEY ?? "",
  ORBY_INSTANCE_PUBLIC_API_KEY: import.meta.env.VITE_ORBY_INSTANCE_PUBLIC_API_KEY ?? "",
  ORBY_RPC_BASE_URL: import.meta.env.VITE_ORBY_RPC_BASE_URL ?? "",
  ORBY_APP_NAME: import.meta.env.VITE_ORBY_APP_NAME ?? "Bullrun",

  // Turnkey
  TURNKEY_ORG_ID: import.meta.env.VITE_TURNKEY_ORG_ID ?? "",
  TURNKEY_AUTH_PROXY_CONFIG_ID: import.meta.env.VITE_TURNKEY_AUTH_PROXY_CONFIG_ID ?? "",
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "",
  APPLE_CLIENT_ID: import.meta.env.VITE_APPLE_CLIENT_ID ?? "",
  TURNKEY_OAUTH_REDIRECT_URI: import.meta.env.VITE_TURNKEY_OAUTH_REDIRECT_URI ?? "",

  // Observability
  POSTHOG_API_KEY: import.meta.env.VITE_POSTHOG_API_KEY ?? "",
  POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com",
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN ?? "",
  SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "development",

  // Mesh
  MESH_CLIENT_ID: import.meta.env.VITE_MESH_CLIENT_ID ?? "",
  MESH_CLIENT_SECRET: import.meta.env.VITE_MESH_CLIENT_SECRET ?? "",
  MESH_SANDBOX: import.meta.env.VITE_MESH_SANDBOX ?? "false",
  MESH_API_URL: import.meta.env.VITE_MESH_API_URL ?? "https://integration-api.meshconnect.com",
  MESH_SANDBOX_API_URL: import.meta.env.VITE_MESH_SANDBOX_API_URL ?? "https://sandbox-integration-api.meshconnect.com",

  // Canonical public URL — used by shared screens (e.g. share links, deep-link detection).
  // Onramp / Crossmint are not wired on web (Crossmint RN UI is stubbed).
  APP_DOMAIN: import.meta.env.VITE_APP_DOMAIN ?? "https://bullrun.finance",
} as const;
